import { useMemo } from 'react';
import { useWorkOrderFlow } from '@/hooks/useWorkOrderFlow';
import { DEFAULT_FLOW_STATUS_KEYS, DEFAULT_TERMINAL_STATUS_KEYS } from '@/lib/workOrderFlowDefaults';
import type { BookingStatus } from '@/types';

/**
 * Work order statuses the calendar can show, in flow order. Quotations never
 * reach the calendar (#2636) and terminal statuses are hidden by default.
 * Shared by the status filter and the status colour legend.
 */
export function useCalendarStatusOptions(): BookingStatus[] {
  const { statuses: flowStatuses } = useWorkOrderFlow();
  return useMemo<BookingStatus[]>(() => {
    if (flowStatuses.length === 0) {
      return DEFAULT_FLOW_STATUS_KEYS
        .filter((key) => !DEFAULT_TERMINAL_STATUS_KEYS.has(key) && key !== 'quote')
        .map((key) => key as BookingStatus);
    }
    return flowStatuses
      .filter((s) => !s.isTerminal && s.key !== 'quote' && s.key !== 'quote_rejected')
      .map((s) => s.key as BookingStatus);
  }, [flowStatuses]);
}
